export const FITNESS_FOCUS_HUB_IDS = new Set(['fitness-hub', 'nutrition-lab']);

export function filterHubNavigationItems(items, fitnessHubsOnly) {
	if (!fitnessHubsOnly) return items;

	return items.filter((item) => FITNESS_FOCUS_HUB_IDS.has(item.id));
}

export function defaultAuthenticatedHomePath(fitnessHubsOnly) {
	if (fitnessHubsOnly) return '/fitness-hub';
	return '/front-office';
}

export function homeLogoPath({
	authenticated,
	fitnessHubsOnly,
	defaultAuthenticatedPath = '/front-office'
}) {
	if (fitnessHubsOnly) return '/fitness-hub';
	if (authenticated) return defaultAuthenticatedPath;
	return '/';
}
